import FolderSharedIcon from '@atlaskit/icon-lab/core/folder-shared';
import * as React from 'react';

export function SvgFolderShared() {
  return <FolderSharedIcon label="" testId="ads-refreshed-icon" />;
}
